// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-wrap {
  width: 109%;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
  height: 97vh;
}

.Info-text {
  font-size: 13px;
  font-family: "opensans", sans-serif;
  color: #474747;
  font-weight: 600;
  display: block;
  margin-bottom: 10px;
  margin-top: 30px;
}

.intro-label {
  font-size: 13px !important;
  font-family: "opensans", sans-serif !important;
  color: #474747 !important;
  display: block !important;
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}

.upload-container {
  display: flex;
  align-items: center;
}

.upload-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #f5f5f5;
  border: 2px dashed #aaa;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.upload-circle:hover {
  border-color: #1c60c6;
  color: #1c60c6;
}

.upload-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-intro-row {
  margin: 0;
}

.input-container {
  margin-bottom: 18px;
}

label {
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.input-style {
  width: 100%;
  padding: 8px 14px !important;
  background-color: white;
  border: 1px solid #dcdcdc;
  border-radius: 8px !important;
  margin-top: 6px;
  font-size: 12px !important;
  color: #555 !important;
  transition: border-color 0.2s ease;
}

.input-style:focus {
  border-color: #6c63ff;
  outline: none;
}

.phone-input-wrapper {
  width: 100%;
}

.phone-input {
  width: 350px;
  padding: 8px 14px;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: border-color 0.2s ease;
}

.phone-input:focus-within {
  border-color: black;
}

.phone-input__input {
  border: none !important;
  width: 100%;
  font-size: 12px;
  color: #555;
  background: transparent;
  outline: none;
}

.phone-input__input::placeholder {
  color: #888;
}

.phone-input .PhoneInputCountry {
  margin-right: 6px;
}

.industry-dropdown {
  width: 350px !important;
  min-width: 0;
  display: block;
}

.industry-dropdown.custom-dropdown .ant-select-selector {
  height: 38px !important;
  min-height: 24px !important;
  padding: 8px 32px 8px 14px !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  color: #555 !important;
  background-color: #fff !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}

.industry-dropdown .ant-select-arrow {
  display: none !important;
}

.industry-dropdown:hover .ant-select-selector {
  border-color: #6c63ff !important;
}

.industry-dropdown.ant-select-focused .ant-select-selector {
  border-color: #6c63ff !important;
  box-shadow: none !important;
}

.industry-dropdown .ant-select-selection-placeholder {
  color: #888 !important;
  font-size: 12px !important;
}

.industry-dropdown .ant-select-selection-item {
  color: #555 !important;
  font-size: 12px !important;
}

.error-message {
  color: #ff4d4f;
  font-size: 13px;
  margin-top: 4px;
}

.image-section .girl {
  width: 100%;
  max-width: 240px;
  display: block;
  margin-left: 10px;
}

.sidebar {
  background: #1e57f1;
  height: 100vh;
  color: white;
  padding: 30px;
}

.sidebar h1 {
  font-size: 24px;
  font-weight: 700;
}

.step-item {
  margin-top: 25px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-item .number {
  width: 28px;
  height: 28px;
  background: #fff;
  color: #1e57f1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
}

.required-star {
  color: red;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/layouts/ProfileSetup/UserIntro.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACE,mCAAA;EACF,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACE,gBAAA;AACJ;;AAEA;EACE,0BAAA;EACA,8CAAA;EACA,yBAAA;EACE,yBAAA;EACF,2BAAA;EACA,6BAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAEF;;AACA;EACE,qBAAA;EACA,cAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;EACA,sBAAA;EACA,kCAAA;AAEF;;AACA;EACE,qBAAA;EACA,aAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,uBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;AAGF;;AAAA;EACE,uBAAA;EACA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,iCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AAGF;;AAAA;EACE,wBAAA;AAGF;;AAAA;EACE,gCAAA;AAGF;;AAAA;EACE,gCAAA;EACA,2BAAA;AAGF;;AAAA;EACE,sBAAA;EACA,0BAAA;AAGF;;AAAA;EACE,sBAAA;EACA,0BAAA;AAGF;;AAAA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAGF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAGF;;AACA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,UAAA;EACA,iBAAA;AAEF","sourcesContent":[".container-wrap {\r\n  width: 109%;\r\n  font-family: \"Inter\", sans-serif;\r\n  box-sizing: border-box;\r\n  height: 97vh;\r\n}\r\n\r\n.Info-text {\r\n  font-size: 13px;\r\n    font-family: 'opensans',sans-serif;\r\n  color: #474747;\r\n  font-weight: 600;\r\n  display: block;\r\n  margin-bottom: 10px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.intro-label {\r\n  font-size: 13px !important;\r\n  font-family: 'opensans',sans-serif !important;\r\n  color: #474747 !important;\r\n    display: block !important;\r\n  font-weight: 600 !important;\r\n  margin-bottom: 5px !important;\r\n}\r\n.upload-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.upload-circle {\r\n  width: 120px;\r\n  height: 120px;\r\n  border-radius: 50%;\r\n  background-color: #f5f5f5;\r\n  border: 2px dashed #aaa;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #555;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.upload-circle:hover {\r\n  border-color: #1c60c6;\r\n  color: #1c60c6;\r\n}\r\n\r\n.upload-circle img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover; \r\n  border-radius: 50%;\r\n}\r\n\r\n.user-intro-row {\r\n  margin: 0;\r\n}\r\n\r\n.input-container {\r\n  margin-bottom: 18px;\r\n}\r\n\r\nlabel {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n.input-style {\r\n  width: 100%;\r\n  padding: 8px 14px !important;\r\n  background-color: white;\r\n  border: 1px solid #dcdcdc;\r\n  border-radius: 8px !important;\r\n  margin-top: 6px;\r\n  font-size: 12px !important;\r\n  color:#555 !important;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.input-style:focus {\r\n  border-color: #6c63ff;\r\n  outline: none;\r\n}\r\n.phone-input-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.phone-input {\r\n  width: 350px;\r\n  padding: 8px 14px;\r\n  background-color: #fff;\r\n  border: 1px solid #dcdcdc;\r\n  border-radius: 8px;\r\n  margin-top: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.phone-input:focus-within {\r\n  border-color: black;\r\n}\r\n\r\n.phone-input__input {\r\n  border: none !important;\r\n  width: 100%;\r\n  font-size: 12px;\r\n  color: #555;\r\n  background: transparent;\r\n  outline: none;\r\n}\r\n\r\n.phone-input__input::placeholder {\r\n  color: #888;\r\n}\r\n\r\n.phone-input .PhoneInputCountry {\r\n  margin-right: 6px;\r\n}\r\n\r\n.industry-dropdown {\r\n  width: 350px !important;\r\n  min-width: 0;\r\n  display: block;\r\n}\r\n\r\n.industry-dropdown.custom-dropdown .ant-select-selector {\r\n  height: 38px !important;\r\n  min-height: 24px !important;\r\n  padding: 8px 32px 8px 14px !important;\r\n  border: 1px solid #dcdcdc !important;\r\n  border-radius: 8px !important;\r\n  font-size: 12px !important;\r\n  color: #555 !important;\r\n  background-color: #fff !important;\r\n  box-shadow: none !important;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.industry-dropdown .ant-select-arrow {\r\n  display: none !important;\r\n}\r\n\r\n.industry-dropdown:hover .ant-select-selector {\r\n  border-color: #6c63ff !important;\r\n}\r\n\r\n.industry-dropdown.ant-select-focused .ant-select-selector {\r\n  border-color: #6c63ff !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.industry-dropdown .ant-select-selection-placeholder {\r\n  color: #888 !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.industry-dropdown .ant-select-selection-item {\r\n  color: #555 !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.error-message {\r\n  color: #ff4d4f;\r\n  font-size: 13px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.image-section .girl {\r\n  width: 100%;\r\n  max-width: 240px;\r\n  display: block;\r\n  margin-left: 10px;\r\n}\r\n\r\n\r\n.sidebar {\r\n  background: #1e57f1;\r\n  height: 100vh;\r\n  color: white;\r\n  padding: 30px;\r\n}\r\n\r\n.sidebar h1 {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n}\r\n\r\n.step-item {\r\n  margin-top: 25px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.step-item .number {\r\n  width: 28px;\r\n  height: 28px;\r\n  background: #fff;\r\n  color: #1e57f1;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.required-star {\r\n  color: red;\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
